<template>
    <!-- 画像ファイル選択 -->
    <div>
        <div style="display: flex; gap: 10px; align-items:center;">
            <button v-if="ObjectUrl==''" style="min-width: 80px" @click="()=>$refs['selector'].click()" :disabled="disabled">画像選択</button>
            <button v-else               style="min-width: 80px" @click="remove" :disabled="disabled">選択取消</button>
            <a target="_blank" style="overflow: hidden; text-overflow: ellipsis" :href="ObjectUrl">{{ FileName }}</a>
        </div>

        <a v-if="ObjectUrl!= ``" target="_blank" :href="ObjectUrl">
            <img style="max-width: 100%; margin-top: 5px;" :src="ObjectUrl" >
        </a>

        <input style="display:none" ref="selector" type="file" accept=".png,.jpg,.jpeg" @change="changed" />
        <canvas style="display:none" ref="canvas"></canvas>
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            default: false,
        },
        maxSize: {
            type: Number,
            default: 10000,
        }
    },
    data() {
        return {
            IsDestoryed: false,
            FileName: "",
            ObjectUrl: "",
            BlobData: null,
        }
    },
    beforeDestroy(){
        this.IsDestoryed = true
        this.remove()
    },
    methods: {
        changed(event) {
            const input = event.currentTarget
            const canvas = this.$refs["canvas"]

            if(input.files.length == 0) return

            const file = input.files[0]
            input.value = ""

            const reader = new FileReader()
            const image = new Image()
            const max = this.maxSize

            reader.onerror = ()=>{
                this.remove()
                this.FileName="!画像が読み込めません"
            }
            reader.onload = ()=>{
                image.src = reader.result
            }

            image.onerror = ()=>{
                this.remove()
                this.FileName="!画像が読み込めません"
            }
            image.onload = () => {
                let w = Math.min(image.width, max, image.width * max / image.height)
                let h = Math.min(image.height, max, image.height * max / image.width)
                canvas.width = w
                canvas.height = h
                canvas.getContext('2d').drawImage(image, 0, 0, w, h)
                
                canvas.toBlob(blob=>{
                    this.remove()
                    if(!this.IsDestoryed){
                        let url = URL.createObjectURL(blob)
                        this.FileName = file.name
                        this.ObjectUrl = url
                        this.BlobData = blob
                    }
                }, "image/jpeg", 0.60)
            }

            reader.readAsDataURL(file)
        },
        remove(){
            if(this.ObjectUrl != ""){
                URL.revokeObjectURL(this.ObjectUrl)
                this.ObjectUrl = ""
                this.FileName = ""
            }
        },

        //コントロール外からの呼び出しを想定

        /**
         * 設定されたデータをbase64エンコードで取得します。
         * @returns {string}
         */
        async getBase64(){
            if(this.ObjectUrl=="") return null

            return new Promise(resolve => {
                const reader = new FileReader()
                reader.onload = ()=>{
                    resolve(reader.result.split(",")[1])
                }
                reader.readAsDataURL(this.BlobData)
            })
        },
        /**
         * 画像データが登録されているか否かを取得します。
         * @return {boolean}
         */
        existFile(){
            return this.ObjectUrl != ""
        }
    },
}
</script>

<style scoped>
</style>